export default __webpack_public_path__ + "static/media/waterBgi1.ee8cac47.svg";